__turbopack_context__.v({
  "BlogDetailContainer": "BlogDetail-module-scss-module__5GsK-W__BlogDetailContainer",
  "BlogDetailInnerCont": "BlogDetail-module-scss-module__5GsK-W__BlogDetailInnerCont",
  "accent": "BlogDetail-module-scss-module__5GsK-W__accent",
  "blogDetailLine": "BlogDetail-module-scss-module__5GsK-W__blogDetailLine",
  "date": "BlogDetail-module-scss-module__5GsK-W__date",
  "line": "BlogDetail-module-scss-module__5GsK-W__line",
  "rpLine": "BlogDetail-module-scss-module__5GsK-W__rpLine",
  "socialShareButtons": "BlogDetail-module-scss-module__5GsK-W__socialShareButtons",
  "tag": "BlogDetail-module-scss-module__5GsK-W__tag",
  "wysiwyg": "BlogDetail-module-scss-module__5GsK-W__wysiwyg",
});
